import {useEffect, useState} from 'react';

/*
 * Returns an up-to-date pathname that can be used as a dependency
 * in hooks. Ideally this should be React Router's `useLocation` but
 * we don't yet have the correct version for that.
 */
export default function usePathname() {
  const [pathname, setPathname] = useState(window?.location.pathname ?? '');

  const onPopstate = () => {
    const newPathname = window?.location.pathname ?? '';
    setPathname(newPathname);
  };

  useEffect(() => {
    window?.addEventListener('popstate', onPopstate);

    return () => {
      window?.removeEventListener('popstate', onPopstate);
    };
  }, []);

  return pathname;
}
